// context/AuthContext.js
import React, { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [authInitialized, setAuthInitialized] = useState(false);

  useEffect(() => {
    const initializeAuth = async () => {
      const token = localStorage.getItem("authToken");
      const userData = localStorage.getItem("user");
      const loggedIn = localStorage.getItem("isLoggedIn");

      if (token && userData && loggedIn === 'true') {
        try {
          const parsedUser = JSON.parse(userData);
          setUser(parsedUser);
          setIsLoggedIn(true);
          
          // Ensure siteId is stored for site_admin users
          if (parsedUser.site_id) {
            localStorage.setItem('siteId', parsedUser.site_id);
            console.log("🏷️ Site ID set from user data:", parsedUser.site_id);
          }
        } catch (error) {
          console.error("Error parsing user data:", error);
          logout();
        }
      }
      setAuthInitialized(true);
    };

    initializeAuth();
  }, []);

  const login = (userData, token) => {
    console.log("🔐 Login called with user:", userData);
    
    localStorage.setItem("authToken", token);
    localStorage.setItem("user", JSON.stringify(userData));
    localStorage.setItem("isLoggedIn", 'true');
    
    // Store site_id for site_admin users
    if (userData.site_id) {
      localStorage.setItem("siteId", userData.site_id);
      console.log("🏷️ Site ID stored:", userData.site_id);
    }
    
    setUser(userData);
    setIsLoggedIn(true);
  };

  const logout = () => {
    console.log("🚪 Logging out...");
    localStorage.removeItem("authToken");
    localStorage.removeItem("user");
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("siteId");
    setUser(null);
    setIsLoggedIn(false);
  };

  const hasRole = (role) => {
    return user?.role === role;
  };

  return (
    <AuthContext.Provider value={{ 
      user, 
      isLoggedIn, 
      login, 
      logout, 
      authInitialized,
      hasRole
    }}> 
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);